import React, { useMemo } from 'react';
import Table from '../Table';
import SearchTable from '../SearchTable';

export default function Teams(props) {
    const columns = useMemo(
        () => [
            {
                Header: 'Country',
                accessor: 'country',
                Cell: props => {
                    if (props.value) {
                        return (
                            <div className="flag proxima">
                                <img
                                    src={`${theme_details.templateUrl}/svgs/${props.value.toLowerCase()}.svg`}
                                    width="34"
                                    height="42"
                                    alt={props.value}
                                    title={props.row.original.country_name}
                                />
                                {props.row.original.iso}
                            </div>
                        );
                    } else {
                        return '';
                    }
                },
            },
            {
                Header: 'Name',
                accessor: 'title',
                Cell: props => <a href={props.row.original.url}>
                    <p className="database-table__title">{props.value}</p>
                    <p className="database-table__subtitle proxima">{props.row.original.subtitle}</p>
                </a>,
            },
            {
                Header: 'Length (Miles)',
                accessor: 'length',
                Cell: props => <p className="database-table__figure proxima">{props.value}</p>,
            },
            {
                Header: 'Start Year',
                accessor: 'starting_year',
                only_desktop: true,
                Cell: props => <p className="database-table__figure proxima">{props.value}</p>,
            },
            {
                Header: 'End Year',
                accessor: 'ending_year',
                only_desktop: true,
                Cell: props => <p className="database-table__figure proxima">{props.value}</p>,
            },
        ],
        [],
    );

    const TableComponent = props.searchTable ? SearchTable : Table;

    return <TableComponent columns={columns} {...props} />;
}
